@if (strategy) {
  <div class="reward">
    <h3>Reward-strategy</h3>
    <mat-form-field>
      <mat-label>Enter the strategy title</mat-label>
      <input matInput type="text" placeholder="" [(ngModel)]="strategy.title" autocomplete="off">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Reward coins</mat-label>
      <mat-select [compareWith]="compareRewardFn" placeholder="" [(ngModel)]="strategy.coinReward">
        <mat-option [value]="null"></mat-option>
        @for (coinReward of coinRewardOptions; track coinReward) {
          <mat-option [value]="coinReward">{{ coinReward.coins }} coins reward</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field fxFlex>
      <mat-label>Reward product</mat-label>
      <mat-select [compareWith]="compareProductRewardFn" placeholder="" [(ngModel)]="strategy.productReward">
        <mat-option [value]="null"></mat-option>
        @for (product of rewardProductsOptions; track product) {
          <mat-option [value]="product" [matTooltip]="product.productSlug">{{ product.rewardTitle }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}




